module.exports = __webpack_public_path__ + "it.1b665793d4ee27964ad7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/it.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/it.svg
// module chunks = styles